var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 5.30577H2.77778C2.1555 5.30577 1.84436 5.30577 1.60668 5.42688C1.39761 5.5334 1.22763 5.70338 1.1211 5.91245C1 6.15013 1 6.46127 1 7.08355V19.0836C1 19.7058 1 20.017 1.1211 20.2547C1.22763 20.4637 1.39761 20.6337 1.60668 20.7402C1.84436 20.8613 2.1555 20.8613 2.77778 20.8613H7.66667M7.66667 20.8613H14.3333M7.66667 20.8613L7.66667 2.63911C7.66667 2.01683 7.66667 1.70569 7.78777 1.46801C7.8943 1.25894 8.06428 1.08896 8.27334 0.982432C8.51102 0.861328 8.82216 0.861328 9.44444 0.861328L12.5556 0.861328C13.1778 0.861328 13.489 0.861328 13.7267 0.982432C13.9357 1.08896 14.1057 1.25894 14.2122 1.46801C14.3333 1.70569 14.3333 2.01683 14.3333 2.63911V20.8613M14.3333 9.75022H19.2222C19.8445 9.75022 20.1556 9.75022 20.3933 9.87132C20.6024 9.97785 20.7724 10.1478 20.8789 10.3569C21 10.5946 21 10.9057 21 11.528V19.0836C21 19.7058 21 20.017 20.8789 20.2547C20.7724 20.4637 20.6024 20.6337 20.3933 20.7402C20.1556 20.8613 19.8445 20.8613 19.2222 20.8613H14.3333",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.fec8dee4c30f4a2287b0e75a6c0bec27.svg";
export { ForwardRef as ReactComponent };